// extracted by mini-css-extract-plugin
export default {"wrapper":"triangle_wrapper__B6sh4","innerWrapper":"triangle_innerWrapper__mdirY"};